export const GET_QUERIES = 'GET_QUERIES';